import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_FLAGS = {
  chatbot_enabled: true,
  stats_enabled: true,
  practice_enabled: true,
  series_enabled: true,
  podcasts_enabled: true,
  scroll_autoplay_enabled: true,
};

const FeatureFlagsContext = createContext({
  flags: DEFAULT_FLAGS,
  loading: true,
  refresh: () => {},
});

export function FeatureFlagsProvider({ children }) {
  const [flags, setFlags] = useState(DEFAULT_FLAGS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/feature-flags`);
      setFlags({ ...DEFAULT_FLAGS, ...(res.data || {}) });
    } catch {
      setFlags(DEFAULT_FLAGS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <FeatureFlagsContext.Provider value={{ flags, loading, refresh }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}

export function useFeatureFlag(key) {
  const { flags } = useContext(FeatureFlagsContext);
  return flags[key] !== false;
}
